import { useEffect, useState } from "react";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, Legend } from "recharts";
import { api, fmtEur } from "@/lib/api";

const MESI = ["gen", "feb", "mar", "apr", "mag", "giu", "lug", "ago", "set", "ott", "nov", "dic"];
const label = (m) => `${MESI[+m.slice(5) - 1]} ${m.slice(2, 4)}`;

const Box = ({ title, value, sub, id }) => (
  <div className="rounded-2xl border p-4" data-testid={`revenue-${id}`}>
    <p className="text-xs uppercase tracking-wide text-slate-500">{title}</p>
    <p className="mt-1 text-2xl font-display font-semibold">{fmtEur(value)}</p>
    {sub && <p className="text-xs text-slate-500 mt-1">{sub}</p>}
  </div>
);

export const RevenuePanel = () => {
  const [r, setR] = useState(null);
  useEffect(() => {
    api.get("/admin/revenue").then(({ data }) => setR(data)).catch(() => setR({ error: true }));
  }, []);
  if (!r) return <div className="mt-6 rounded-3xl border bg-white p-6 text-sm text-slate-500" data-testid="revenue-loading">Caricamento incassi…</div>;
  if (r.error) return <div className="mt-6 rounded-3xl border bg-white p-6 text-sm text-red-600" data-testid="revenue-error">Impossibile caricare gli incassi.</div>;
  const c = r.current;
  return (
    <div className="mt-6 rounded-3xl border bg-white p-6" data-testid="revenue-panel">
      <h3 className="font-medium mb-4">Incassi per metodo di pagamento</h3>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-6">
        <Box title={`Carta · ${label(c.month)}`} value={c.card} id="current-card" />
        <Box title={`PayPal · ${label(c.month)}`} value={c.paypal} id="current-paypal" />
        <Box title="Carta · dall'inizio" value={r.card_total} id="total-card" />
        <Box title="PayPal · dall'inizio" value={r.paypal_total} id="total-paypal" />
      </div>
      <div className="h-72" data-testid="revenue-chart">
        <ResponsiveContainer>
          <BarChart data={r.series}>
            <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" />
            <XAxis dataKey="month" tickFormatter={label} fontSize={12} />
            <YAxis fontSize={12} tickFormatter={(v) => `${v} €`} />
            <Tooltip formatter={(v) => fmtEur(v)} labelFormatter={label} />
            <Legend />
            <Bar dataKey="card" name="Carta (Stripe)" stackId="a" fill="#1E3A8A" />
            <Bar dataKey="paypal" name="PayPal" stackId="a" fill="#FFC439" radius={[6, 6, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
